//
// Generated class OnlineMenu
//

/// <reference path="OnlineMenu_ManagedObject.ts" />

class OnlineMenu extends OnlineMenu_ManagedObject
{

}
